/** The minimal shape this constraint reads: only `isFileDeclared` drives whether the file is valid. */
type FileRequirementShape = {
	readonly isFileDeclared: boolean;
};

/**
 * Generic over the minimal shape it reads, not over `DocumentTemplateUploadFormData` itself
 * (`guides/forms.md` §1.1). A file is selected but not yet described, or described with a preview
 * other than `declared`, counts the same as no file at all: the deposit stays blocked either way.
 * `isFileDeclared` is written by the sidebar once the local preview settles, never by Joi.
 */
function isDeclaredFileSelected<T extends FileRequirementShape>(value: File | null, formData: T): boolean {
	return value !== null && formData.isFileDeclared;
}

export default isDeclaredFileSelected;
